import { render } from "./TrixField.vue?vue&type=template&id=018385ea"
import script from "./TrixField.vue?vue&type=script&lang=js"
export * from "./TrixField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrixField.vue"]])

export default __exports__